import type { Language } from "../contexts/LanguageContext";

export const sidebarLabels: Record<Language, { logout: string }> = {
  pt: { logout: "Sair" },
  en: { logout: "Logout" },
};

